import React from "react";
import { ImageKit } from "@aph/ui-lib-humanx";
import { DeviceInfo } from "@/interface/deviceInfo";
import styles from "./VideoCard.module.scss";

interface Props {
  onClick?: (e: any) => void;
  className?: string;
  thumbNailImage?: string;
  title?: string;
  thumbnailAlt?: string;
  tags?: any;
  redirectUrl?: string;
  AuthorName?: string;
  userAgent?: DeviceInfo;
  isImageEagerload?: boolean;
  bookmark?: any;
  thumbnailSecond?: number;
}

const VideoCard = ({
  className,
  onClick,
  thumbNailImage,
  title,
  thumbnailAlt = title,
  tags,
  redirectUrl,
  AuthorName,
  userAgent,
  isImageEagerload,
  bookmark,
  thumbnailSecond = null,
}: Props) => {
  const tagsToShow = tags?.length > 2 ? tags?.slice(0, 2) : tags;

  return (
    <a href={redirectUrl} aria-label="video Card" className={styles.anchorTag} onClick={(e) => e.preventDefault()}>
      <div className={`${styles.VideoCardWrap} ${className}`} onClick={onClick}>
        <div className={styles.thumbNail}>
          <ImageKit
            alt={thumbnailAlt}
            src={thumbNailImage}
            {...(thumbnailSecond ? { thumbnailSecond } : {})}
            width={userAgent?.isDesktop ? 304 : 328}
            height={userAgent?.isDesktop ? 206 : 223}
            eagerLoad={isImageEagerload}
          />
          <div className={styles.videoIcon}>
            <div className={styles.triangleRight} />
          </div>
        </div>
        <div className={styles.content}>
          {tagsToShow && (
            <div className={styles.tags}>
              {tagsToShow?.map(({ TagName, id }) => {
                return (
                  <span className={styles.tag} key={`tag_${id}`}>
                    {TagName}
                  </span>
                );
              })}

              {tags?.length > 2 && <span className={styles.tag}>{`+${tags?.length - 2}`}</span>}
            </div>
          )}
          <div className={styles.titleAndBookmark}>
            {title && <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
            {bookmark && <div className={styles.bookmark}>{bookmark}</div>}
          </div>
          {AuthorName && userAgent?.isMobile && <div className={styles.authorName}>By {AuthorName}</div>}
        </div>
      </div>
    </a>
  );
};

export default VideoCard;
